const API_BASE = window.env.API_BASE_URL;


interface InitResponse {
  ok: boolean;
  error?: string;
  user?: {
    id: number;
    username: string;
  };
  data?: {
    id: number;
    title: string;
    content: string;
  };
}

export const checkAccessWithResponse = async (content_id: number, tgId:string): Promise<InitResponse> => {
    try {
        const url = `${API_BASE}/api/v1/knowledge/init?content_id=${content_id}&tg_id=${tgId}`;

        const response = await fetch(url, {
            method: "GET",
        });

        if (!response.ok) {
            const errorText = await response.text().catch(() => "No error details available");
            console.error(`[knowledge.ts] API error: ${response.status} - ${errorText || response.statusText}`);
            throw new Error(`API error (${response.status}): ${errorText || response.statusText}`);
        }

        const data = await response.json();
        console.log(`[knowledge.ts] Response data:`, data);
        return data;
    } catch (error) {
        console.error(`[knowledge.ts] Error in checkAccessWithResponse:`, error);
        if (error instanceof Error) {
            throw error;
        } else {
            throw new Error("Network error: Unable to connect to the API server");
        }
    }
}
